import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { createContext, ReactNode, useContext } from 'react';
import { GeolocationData } from './types';

const GeolocationContext = createContext<UseQueryResult<GeolocationData, Error> | undefined>(undefined);
const GEOLOCATION_RETRY_COUNT = 3;

const fetchGeolocation = async (): Promise<GeolocationData> => {
  const response = await fetch('https://ipapi.co/json/');

  if (!response.ok) {
    throw new Error(`Geolocation request failed: ${response.status}`);
  }

  return response.json();
};

export const GeolocationProvider = ({ enabled = true, children }: { enabled?: boolean, children: ReactNode }) => {
  const queryResult: UseQueryResult<GeolocationData, Error> = useQuery({
    queryKey: ['geolocation'],
    queryFn: fetchGeolocation,
    retry: GEOLOCATION_RETRY_COUNT,
    enabled,
  });

  return (
    <GeolocationContext.Provider value={queryResult}>
      {children}
    </GeolocationContext.Provider>
  );
};

export const useGeolocation = () => {
  const context = useContext(GeolocationContext);

  if (!context) {
    throw new Error('useGeolocation must be used within a GeolocationProvider');
  }

  return context;
};
